import { Fragment} from 'react';
import { Row} from 'react-bootstrap';
import { useActivityContext } from '../context';
import PropTypes from 'prop-types';
import NoAssignment from '../../../assets/images/NoAssignment.png';
import ActivityCreateContent from './ActivityCreateContent';

const EmptyActivitiesState = () => {
  const allActivitiesData = useActivityContext();

  const LayOut = () => {
    return (
      <Row className="align-items-center mb-4">
        {!allActivitiesData.isActivitiesAvailable && (
          <div className="no-assignments-card my-4">
            <div className="text-center no-assignments-icon mb-5">
              <img src={NoAssignment} className="my-4" />
              <p className="mb-4">
                                The flashcard list is currently empty, use the below form to create a new flashcard.
              </p>
            </div>
            <ActivityCreateContent showBrowseContent={false} showTitle={true} fromActivities={true} filters={allActivitiesData.filters}/>
          </div>
        )}
      </Row>
    );
  };

  LayOut.propTypes = {
    children: PropTypes.node
  };

  return (
    <Fragment>
      <LayOut></LayOut>
    </Fragment>
  );
};

EmptyActivitiesState.propTypes = {
  children: PropTypes.node
};

export default EmptyActivitiesState;
